import { RootState } from 'editor/src/store/index';

const isStaticFlagChangeAllowed = (state: RootState) => state.hostSettings.allowStaticFlagChange;

export default isStaticFlagChangeAllowed;
